import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LocationState {
  selectedCity: string | null;
  coordinates: { lat: number; lng: number } | null;
  isLoading: boolean;
  hasPromptedUser: boolean;

  // Actions
  setLocation: (city: string, lat: number, lng: number) => void;
  clearLocation: () => void;
  setHasPromptedUser: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedCity: 'Quezon City', // Default city
      coordinates: { lat: 14.676, lng: 121.0437 }, // Default to Quezon City coordinates
      isLoading: false,
      hasPromptedUser: false,

      setLocation: (city, lat, lng) =>
        set({
          selectedCity: city,
          coordinates: { lat, lng },
        }),

      clearLocation: () =>
        set({
          selectedCity: null,
          coordinates: null,
        }),

      setHasPromptedUser: (value) => set({ hasPromptedUser: value }),

      setLoading: (loading) => set({ isLoading: loading }),
    }),
    {
      name: 'rescue-foodies-location', // Updated to match story requirements
      partialize: (state) => ({
        selectedCity: state.selectedCity,
        coordinates: state.coordinates,
        hasPromptedUser: state.hasPromptedUser,
        // Don't persist isLoading
      }),
    }
  )
);
